import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function FormsInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.FORMS_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={<img src='/include/images/onboarding/forms.svg' alt='Forms' />}
            title='What are forms?'
            body={
                <p>
                    <BulletedList
                        bullets={[
                            <span key='bullet-1'>
                                Design forms to collect new contacts and leads from your website
                            </span>,
                            <span key='bullet-2'>
                                Create your form in Nutshell and embed it on your website with a
                                simple code snippet
                            </span>,
                            <span key='bullet-3'>
                                Seamlessly direct new contact information and leads into Nutshell
                            </span>,
                        ]}
                    />
                </p>
            }
            learnEvenMoreHref='https://www.nutshell.com/features/forms'
        />
    );
}
